import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { RequestIdService } from './request-id.service';
import { RegTokenService } from './reg-token.service';

import { UserBaseModel, UserService as ApiUserService } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class RecoveryService {

  constructor(
    private apiUserService: ApiUserService,
    private requestIdService: RequestIdService,
    private regTokenService: RegTokenService,
    private authService: AuthService
  ) {
  }

  checkPhone(phone: string) {
    return this.apiUserService.userRecoveryPassword2faCodePost({
      phone_number: phone,
      country_code: '375'
    }).pipe(map(this.requestIdService.save(phone)));
  }

  confirmation(code: string) {
    return this.apiUserService.userRecoveryPassword2faVerifyPost({
      code: code,
      phone_number: this.requestIdService.value.phoneNumber,
      request_id: this.requestIdService.value.requestId
    }).pipe(map(this.regTokenService.save(this.requestIdService.value.phoneNumber)));
  }

  reg(user: UserBaseModel) {
    return this.apiUserService.userRecoveryPasswordPost({
      ...user,
      registration_token: this.regTokenService.value.token
    })
      .pipe(mergeMap((res) => {
        this.authService.currentTokenValue = res.meta.token;

        return this.authService.authorize();
      }));
  }
}
